import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./index.module.scss";
import Button from "../../../common/button";
import { getBacket } from "../../../../redux/action-creaters/basket";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";

// eslint-disable-next-line import/no-unresolved
import "swiper/css";
import {
  CART_GOALS,
  ECOMMERCE_LISTS,
  reachCartGoal,
  useEcommerce,
  useEcommerceImpressions,
} from "../../../../utils/tracking";
import { getPictureById } from "../../../../utils";
import { ApiClient } from "../../../../api/client";

export default function BuyWithThis({ products }) {
  const buyWithThisProduct = Array.isArray(products) ? products : [];
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { trackAdd } = useEcommerce();

  useEcommerceImpressions(buyWithThisProduct, ECOMMERCE_LISTS.buyWithThis);

  return (
    buyWithThisProduct?.length > 0 && (
      <div data-test="buyWithThisBlock">
        <div className={styles.Title}>Дополнительные товары</div>
        <div className={styles.Services}>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={20}
            className="swiper-auto-width"
          >
            {buyWithThisProduct.map((item) => (
              <SwiperSlide key={`${item.CODE}`}>
                <a
                  className={styles.Service}
                  key={item.ID}
                  data-test="buyWithThisItem"
                  target={"_blank"}
                  rel="noreferrer"
                  href={item.DETAIL_PAGE_URL}
                >
                  <div className={styles.Image}>
                    <img src={getPictureById(item.PHOTOS_NEW?.[0])?.small} />
                  </div>
                  <div className={styles.Art}>
                    Артикул: {item.ARTICLE.VALUE}
                  </div>
                  <span data-test="buyWithThisItemName" className={styles.Name}>
                    {item.NAME}
                  </span>
                  <span className={styles.Price}>{item.CATALOG.PRICE} руб</span>
                  <div className={styles.Buttons}>
                    <Button
                      onClick={async () => {
                        setIsAddingToCart(true);
                        await ApiClient.basket.addProductToBasket(
                          item.ID,
                          item.CART_PROPS || null,
                        );
                        await dispatch(getBacket(true));
                        await dispatch(showPopup(popupTypes.cart));
                        setIsAddingToCart(false);

                        reachCartGoal(CART_GOALS.addToCart, user);
                        trackAdd(item, { list: ECOMMERCE_LISTS.buyWithThis });
                      }}
                      label={"Купить"}
                      test="buyWithThisBuyButton"
                      isLoading={isAddingToCart}
                    />
                    <Button
                      type="outline"
                      test="buyWithThisOneClickButton"
                      label="Заказать в 1 клик"
                      onClick={() => {
                        dispatch(
                          showPopup(popupTypes.buyOneClick, {
                            id: item.ID,
                          }),
                        );
                      }}
                    />
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  );
}
